<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<template>
			<!-- 재검사 -->
			<sf-button v-if="isButton_(scrId, 'RI')" line size="lg" icon="download" :onClick="() => reInsPopup()">
				{{ getMessage_('QWCC000054') }}
			</sf-button>
		</template>
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-24">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<div class="sf-datatable-wrapper">
						<div class="sf-datatable-container">
							<div class="sf-table">
								<table class="qms-table">
									<tbody>
										<tr>
											<!-- 품번 -->
											<th class="col-1">{{ getMessage_('QWCC000956') }}</th>
											<td class="col-3">
												<el-input
													id="rmk"
													type="input"
													v-model="reInsPopupParams.partNo"
													:inputValue="reInsPopupParams.partNo"
													@change="value => onChangeParam({ key: 'partNo', value })"
													:readonly="true"
												/>
											</td>
											<!-- 품명 -->
											<th class="col-1">{{ getMessage_('QWCC000957') }}</th>
											<td class="col-3">
												<el-input
													id="rmk"
													type="input"
													v-model="reInsPopupParams.partNm"
													:inputValue="reInsPopupParams.partNm"
													@change="value => onChangeParam({ key: 'partNm', value })"
													:readonly="true"
												/>
											</td>
										</tr>
										<tr>
											<!-- 검사번호 -->
											<th class="col-1">{{ getMessage_('QWCC000005') }}</th>
											<td class="col-3">
												<el-input
													id="rmk"
													type="input"
													v-model="reInsPopupParams.ckuNo"
													:inputValue="reInsPopupParams.ckuNo"
													@change="value => onChangeParam({ key: 'ckuNo', value })"
													:readonly="true"
												/>
											</td>
											<!-- 재검사 수량 -->
											<th class="col-1">{{ getMessage_('QWCC001890') }}</th>
											<td class="col-3">
												<el-input
													inputType="input"
													v-model="reInsPopupParams.reInsQty"
													@input="value => input(value, 'reInsQty')"
													maxlength="2"
													show-word-limit
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false
		};
	},
	async created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('QWCC001894');
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(params) {
			this.show = true;
			let { partNo, ckuNo, partNm } = params;

			this.onChangeParam({ key: 'partNo', value: partNo });
			this.onChangeParam({ key: 'partNm', value: partNm });
			this.onChangeParam({ key: 'ckuNo', value: ckuNo });
			this.onChangeParam({ key: 'reInsQty', value: '' });
		},
		close() {
			this.show = false;
		},
		onChangeParam(payload) {
			// console.log('payload >>> ', payload);
			this.$sf_toggleLoading(true);
			this.setReInsPopupParams_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		//input 숫자만 입력가능
		input(value, target) {
			let numberRegEx = /[^0-9]/g; //숫자만 입력가능
			let val = value.replace(numberRegEx, '');
			this.onChangeParam({ key: target, value: val });
		},
		reInsPopup() {
			try {
				this.$sf_toggleLoading(true);
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001299'), //재검사처리 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC000054'), clickFn: () => this.saveReInsp() }] //재검사
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async saveReInsp() {
			this.$sf_toggleLoading(true);

			try {
				const reInsPopupParams = this.reInsPopupParams;
				const { header, body } = await this.saveReInspPopup_(reInsPopupParams);
				// console.log('header >>>>> ', header);
				// console.log('body >>>>> ', body);
				// console.log('body partCkuInfo >>>>> ', body.partCkuInfo);
				const resultData = body.partCkuInfo;
				if (header.code === 0) {
					this.$sf_toast({
						type: header.code === 0 ? 'ok' : 'error',
						message: this.getMessage_(header.messageCd)
					});
					this.$emit('RefreshReIns', resultData);
				} else if (header.code === 3) {
					this.$sf_toast({
						type: header.code === 0 ? 'ok' : 'error',
						message: this.getMessage_(header.messageCd)
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
